import React, { useEffect, useState, useRef } from "react";
import { Modal, Radio } from "antd";
import SignagePlayer from "../SignagePlayer";
import { LeftCircleOutlined, RightCircleOutlined } from '@ant-design/icons';

const PreviewPlaylist = ({ isModalOpen, playlist, closeModal }) => {
  // "horizontal"/"vertical" are kept as the internal values since the
  // preview-media CSS classes key off them - only the displayed labels
  // are Landscape/Portrait to match the orientation field elsewhere.
  const [orientation, setOrientation] = useState(
    playlist.orientation === "portrait" ? "vertical" : "horizontal"
  );
  const playerRef = useRef();

  const handleOrientationChange = (e) => {
    setOrientation(e.target.value);
  };

  const modalWidth = orientation === "horizontal" ? 450 : 275; // adjust as needed
  // Matches the fixed preview-media.horizontal/.vertical CSS dimensions -
  // must track orientation, otherwise the container (and the TV frame
  // wrapping it) stays a fixed 400px tall for both, making the landscape
  // frame come out nearly square instead of a wide 16:9 shape.
  const playerHeight = orientation === "horizontal" ? 225 : 400;

  return (
    <Modal
      title={`Preview Playlist - ${playlist.title}`}
      open={isModalOpen}
      onCancel={() => {
        closeModal();
      }}
      footer={null}
      maskClosable={false}
    >
      <div className="mb-3">
        <label className="form-label me-3">Orientation</label>
        <Radio.Group
          onChange={handleOrientationChange}
          value={orientation}
          optionType="button"
          buttonStyle="solid"
        >
          <Radio value="horizontal">Landscape</Radio>
          <Radio value="vertical">Portrait</Radio>
        </Radio.Group>
      </div>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div className={`tv-frame ${orientation}`}>
          <div
            className={`preview-media-container ${orientation}`}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: playerHeight,
              overflow: "hidden",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              {playlist.media.length > 1 && <LeftCircleOutlined style={{ fontSize: 25, marginRight: 10 }} onClick={() => {
                  playerRef.current?.prevMedia();
              }} />}
              <SignagePlayer
                ref={playerRef}
                playlist={playlist.media.map((media) => {
                  return { media: media, duration: media.duration };
                })}
                classNames={`preview-media ${orientation}`}
                enableControls={true}
              ></SignagePlayer>
              {playlist.media.length > 1 && <RightCircleOutlined style={{ fontSize: 25, marginLeft: 10 }} onClick={() => {
                  playerRef.current?.nextMedia();
              }} />}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default PreviewPlaylist;
